<template>
    <div class="col backgroundForm">
        <div class="col-12 col-md-10 offset-md-1">
            <h3 class="col" align="center">Descargo de Ingresos por Operaciones </h3>
            <form @submit.prevent="searchDischarge">
                <div class="btn-group btn-group-toggle col-12 col-md-10" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch" value="enroll" checked> Matriculacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="oper"> Operacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" v-model="optionSearch" value="renew"> Renovacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios4" v-model="optionSearch" value="penalty"> Sanción
                    </label>
                </div>
                
                <div class="form-row">
                    <div class="form-group col offset-md-3 col-md-6">
                        <label for="captain_download" class="badge badge-info">CAPITANIA</label>
                        <transition name="fade" mode="out-in">
                            <select v-if="dRolUser" name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                                <option v-for="port in port_local" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>
                            <div v-else class="alert alert-success">
                                {{ cSessionUser.name_port }}
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col col-md-6">
                        <label for="date_init_discharge" class="badge badge-info">DEL:</label>         
                        <input type="date" class="form-control" id="date_init_discharge" name="date_init_discharge" v-model="date_init" placeholder="DD/MM/YYYY" autocomplete="off">
                    </div>
                    <div class="form-group col col-md-6">
                        <label for="date_end_discharge" class="badge badge-info">AL:</label>         
                        <input type="date" class="form-control" id="date_end_discharge" name="date_end_discharge" v-model="date_end" placeholder="DD/MM/YYYY" autocomplete="off">
                    </div>
                </div>
                <button class="btn btn-outline-primary col col-md-4 offset-md-4"><font-awesome-icon icon="list" /> Listar</button>
            </form>
        </div>
        <br>
        <transition name="fade">
        <div v-if="debts_local">
            <div class="col col-md-4 offset-md-7" align="right">
                <h6>Total a descargar: <span class="badge badge-secondary">{{ total_select }}</span></h6>
            </div>
            <div class="col col-md-4 offset-md-7" align="right">
                <label> Seleccionar Todo </label>    
                <input type="checkbox" id="selAll" value="selA" v-model="select_all" @click="selectAll($event)">        
            </div>
            
            <div class="table-responsive">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th>#</th>
                            <th scoped="col">Operacion</th>
                            <th scoped="col" class="d-none d-md-block">Capitan de Puerto</th>
                            <th scoped="col">Tramite</th>
                            <th scoped="col">Total</th>
                            <th scoped="col">Agregar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(debt, index) in debts_local" :key="debt.idDownload">
                            <td>{{ index+1 }}</td>
                            <td>{{ debt.operation }}</td>
                            <td class="d-none d-md-block">{{ debt.responsability }}</td>
                            <td>{{ debt.correlative }}/{{ debt.anio }}</td>
                            <td>{{ debt.total }}</td>
                            <td align="center">                           
                                <input type="checkbox" :id="debt.id_download" :value="debt" name="customCheck" v-model="debt.select" @click="checkChange($event, debt)">     
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 col-md-3 offset-md-9">
                <button class="btn btn-block btn-success" :disabled="total_select > 0 ? false : true " @click="nextDischarge">Siguiente <font-awesome-icon icon="chevron-circle-right"> </font-awesome-icon></button>
            </div>

        </div>
        </transition>
    </div>

</template>

<script>
import axios from 'axios';
import Vue from 'vue';

export default {
    name:'discharge',
    data(){
        return{
            optionSearch:'enroll',
            date_init:null,
            date_end:null,
            port_local:[],
            port_select:null,
            debts_local:null,
            select_all:false,
            dRolUser:false
        }
    },
    mounted(){
        this.getToday(),
        this.chargeInit()
    },
    methods:{
         mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;
            setTimeout(()=>{
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
                
                this.optionSearch=radioV;
                this.debts_local=null;
                this.$store.dispatch('sDebtsP/clearDebts', true);
            },200)                
        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.date_init=date_aux;
            this.date_end=date_aux;
            
        },
        async searchDischarge(){
            // enviar la capitania el id con async y await 
            // console.log(this.date_init+ ' ' +this.date_end+' '+this.optionSearch+' '+this.port_select.id);
            let auxPort;
            this.debts_local=null;
            auxPort=this.dRolUser ? this.port_select.id : this.cSessionUser.portId;
            this.select_all=false;
            this.$store.dispatch('sDebtsP/clearDebts', true);
            if(this.date_init != null && this.date_end != null && auxPort != null){
                try {
                    // const debts= await axios.get('getDebts/'+this.date_init+'/'+this.date_end+'/'+this.optionSearch+'/'+auxPort+'?api_token='+Vue.auth.getToken());    
                    // const debts= await axios.get(`getDebts/${this.date_init}/${this.date_end}/${this.optionSearch}/${auxPort}`);    
                    const debts= await axios.get(`getDebts/${this.date_init}/${this.date_end}/${this.optionSearch}/${auxPort}?api_token=${Vue.auth.getToken()}`);    
                    if(debts.data.length > 0){
                        let auxDeb=debts.data;
                        let n_debts=[];
                        
                        auxDeb.forEach(item => {
                            // let o= (item.operation === 'M') ? 'MATRICULACION': item.operation;                            
                            let o = '';
                            let type_op='';
                            switch(item.operation){
                                case 'M':
                                    o='MATRICULACION';
                                break;

                                case 'R':
                                    o='RENOVACION';
                                break;

                                default:
                                    o=item.operation;
                                break;
                            }
                            // console.log(item.t_dispatch);
                            type_op=item.t_dispatch === 'M' ? '(MULTA)': '';
                            o=o+' '+type_op;
                            let aux_job_days=item.job_days > 0 ? `${o}/AUTORIZACION PLAN ACTIVIDADES`:o;
                            let auxitem={
                                id_download:item.id_download,
                                operation:`${aux_job_days}`,
                                responsability:item.responsability,
                                correlative:item.correlative,
                                anio:item.anio,
                                total:item.total,
                                module:this.optionSearch,
                                port:item.port,
                                select:false,
                                date_document:item.date_document
                            }
                            n_debts.push(auxitem)
                        });
                        // this.debts_local=debts.data;
                        this.debts_local=n_debts;
                    }else{
                        toastr.info('No existen Pendientes', 'Sin Registro');
                    }
                } catch (error) {
                    toastr.info('No existen Pendientes', 'Sin Registro');
                }
            }else{
                toastr.info('Verifique que los campos esten completos', 'Advertencia')
            }

        },
        async chargeInit(){
            //   llamar al loading hasta esperar que complete todos los datos del formulario hacer lo mismo en la aprobacion de la matricula

            // const ports = await axios.get('getPorts?api_token='+Vue.auth.getToken());        
            // const ports = await axios.get(`getPorts`);        
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            this.port_local=ports.data;

            this.$store.dispatch('sDebtsP/clearDebts', true);
            this.$store.dispatch('sDocDebts/clearDocument', true);
            this.dRolUser= this.cSessionUser.role === 3 ? true:false;
        },
        
        checkChange(event, dts){
            
            if(event.target.checked){                
                this.$store.dispatch('sDebtsP/addDebts', dts);
            }else{
                this.$store.dispatch('sDebtsP/deleteItemDebts', event.target.id);
            }
            
        },
        selectAll(event){
            if(event.target.checked){
                this.$store.dispatch('sDebtsP/clearDebts', true);
                this.debts_local.forEach(item => {
                    item.select=true;
                    this.$store.dispatch('sDebtsP/addDebts', item);
                })
            }else{
                this.debts_local.forEach(item => {
                    item.select=false;                    
                });
                this.$store.dispatch('sDebtsP/clearDebts', true);
            }
        },
        mVerificaSeleccionAmbas(){
            // console.log(this.list_select_store);
            // aqui vaciamos los datos del storage a un auxiliar
            let aux_store_cant=[];
            let aux_local_cant=[];
            this.list_select_store.forEach((elr)=>{
                let ids=aux_store_cant.findIndex(aid=> aid.id === elr.idDownload );
                if(ids===-1){
                    // no lo encontro y procedemos a registrarlo con la cantidad de veces que aparece
                    // console.log(ids.length);
                    let aux={
                        id:elr.idDownload,
                        formulario:`${elr.correlative}/${elr.anio}`,
                        cant:1
                    }
                    aux_store_cant.push(aux);
                }else{
                    // si encontro el registro
                    let cant_aux=aux_store_cant[ids].cant+1;
                    aux_store_cant[ids].cant=cant_aux;
                }
            })

            // aqui vaciamos de los recibidos del servidor
            this.debts_local.forEach((ell)=>{
                let ids=aux_local_cant.findIndex(aid=> aid.id ===ell.id_download );
                if(ids===-1){
                    // no lo encontro y procedemos a registrarlo con la cantidad de veces que aparece
                    // console.log(ids.length);
                    let aux={
                        id:ell.id_download,
                        formulario:`${ell.correlative}/${ell.anio}`,
                        cant:1
                    }
                    aux_local_cant.push(aux);
                }else{
                    // si encontro el registro
                    let cant_aux=aux_local_cant[ids].cant+1;
                    aux_local_cant[ids].cant=cant_aux;
                }
            })

            // aqui controlamos que lo del storage este la cantidad de cada item de acuerdo
            let cv=0
            // console.log(aux_store_cant);
            // console.log(aux_local_cant);
            aux_store_cant.forEach(elstor=>{
                console.log(`form: ${elstor.formulario} cant:${elstor.cant}`)
                let idxl=aux_local_cant.findIndex(elld => elld.id === elstor.id );
                if(elstor.cant !== aux_local_cant[idxl].cant){
                    // si la cantidad es diferente
                    toastr.warning(`Verifique la seleccion del formulario ${elstor.formulario}`);
                    cv=+1;
                }
            })
            if(cv>0){
                return false;
            }
            else{
                return true;
            }
        },
        nextDischarge(){
            // console.log('pasando a la siguiente ventana');
            if(this.mVerificaSeleccionAmbas()){
                this.$router.push('discharge-document');
            }
        }
    },
    computed:{
        total_select(){
            return this.$store.getters['sDebtsP/getDebtsTotal'];
        },
        list_select_store(){
            return this.$store.getters['sDebtsP/getDebtsPending'];
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/finanzas/Descargo.vue